module.exports = __webpack_public_path__ + "2c44cc65d0aefd6c04a3304108f08bab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-4.png
// module id = 2578
// module chunks = 0